import { ErnotsConfig } from "../../ErnotsConfig";

export const AbbreviationExplanations =
{
    header: <div>
        <p>
            When {ErnotsConfig.AppName} parses a book, it splits text by looking for sentence-ending punctuation - periods, exclamation marks and question marks.
        </p>
        <p>
            Annoyingly, periods are also used in abbreviations. It's not appropriate to split the text on "Mr." or "Dr." or "Cmd." Here, you can define the abbreviations that appear in your text. You can also define them separately for each book, but if you create a list here, you can reuse it for your entire reading list.
        </p>
        <p>
            Any word that's just a single letter followed by a period is automatically considered an abbreviation.
        </p>
    </div>,
    publicObject: "An abbreviation added by the administrator, something that you'll almost certainly want. You can't delete it from here, but you can remove it from a specific book if it's not applicable."
};